<template>
    <div id="bannersContainer">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/admin/publishers">??Publishers</router-link></li>
                <li class="breadcrumb-item"><router-link to="/admin/publishers/publisherId">?? Publisher name</router-link></li>
                <li class="breadcrumb-item active">??Banners</li>
            </ol>
        </nav>
        <div class="page-header">
            <h3>?? Publisher name</h3>
        </div>
        <div class="card">
            <div class="card-body">
                TODO - Show form
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
#bannersContainer {
    position: relative;
    width: 100%;
    height: 100%;
}

.page-header {
    text-align: left;
}

.card {
    position: relative;
    width: 100%;
    bottom: 0px;
    text-align: left;
}
</style>